// extracted by mini-css-extract-plugin
export default {"button":"button_button__AGefk","left":"button_left__M5yIw","right":"button_right__sdE0z"};